export enum SeatType {
    DEFAULT = 'DEFAULT',
    OCUPIED = 'OCUPIED',
    UNAVAILABLE = 'UNAVAILABLE',
    REDUCED_MOBILITY = 'REDUCED_MOBILITY',
    OBESITY = 'OBESITY',
    HIDDEN = 'HIDDEN'
}